import type { CSSProperties } from "react";

export const overlayThemes = {
  light: "#f7f5ef",
  dark: "#202724"
} as const;

export function overlayThemeVariables(background: string): CSSProperties {
  const dark = background.toLowerCase() === overlayThemes.dark;
  return {
    "--overlay-action-bg": background,
    "--overlay-action-fg": dark ? "#f7f5ef" : "#202724",
    "--overlay-action-muted": dark ? "#c4cbc7" : "#68706c",
    "--overlay-action-surface": dark ? "#303835" : "#ffffff",
    "--overlay-action-border": dark ? "rgba(255,255,255,.16)" : "rgba(32,39,36,.13)",
    "--overlay-action-active-bg": dark ? "#f7f5ef" : "#202724",
    "--overlay-action-active-fg": dark ? "#202724" : "#ffffff"
  } as CSSProperties;
}
